import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const CostCustomSoftware6 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="costCustomSoftware" section="overlookedCosts">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="costCustomSoftware:overlookedCosts" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default CostCustomSoftware6;
